(function () {
  var AR_KEYS = {
    "59FIFTY": true,
    "9FIFTY": true,
    "39THIRTY": true,
    "9FORTY": true
  };

  var OPTION_WEIGHTS = {
    fitted: { "59FIFTY": 3 },
    adjustable: { "9FORTY": 3 },
    stretch_fit: { "39THIRTY": 3 },
    snapback: { "9FIFTY": 3 },
    flat_visor: { "59FIFTY": 2, "9FIFTY": 2 },
    curved_visor: { "9FORTY": 2, "39THIRTY": 2 },
    structured: { "59FIFTY": 2, "39THIRTY": 1 },
    unstructured: { "9FORTY": 2 },
    no_preference_crown: { "9FORTY": 1 },
    everyday: { "9FORTY": 2, "59FIFTY": 1 },
    sports: { "59FIFTY": 2, "39THIRTY": 2 },
    streetwear: { "9FIFTY": 2, "59FIFTY": 1 },
    golf_outdoors: { "9FORTY": 2 },
    high_profile: { "9FIFTY": 2, "59FIFTY": 1 },
    mid_profile: { "39THIRTY": 1, "9FORTY": 1, "59FIFTY": 1 },
    low_profile: { "9FORTY": 2 },
    no_preference: {}
  };

  var DEFAULT_QUESTIONS = [
    {
      id: "q1",
      question: "¿Cómo te gusta que te quede la gorra?",
      subtitle: "Nos ayuda a definir el tipo de cierre.",
      options: [
        { id: "fitted", label: "Fitted – Ajuste preciso y ceñido" },
        { id: "adjustable", label: "Ajustable – Cómoda y flexible" },
        { id: "snapback", label: "Snapback – Clásica y regulable" },
        { id: "stretch_fit", label: "Stretch-Fit – Lo mejor de ambas" }
      ]
    },
    {
      id: "q2",
      question: "¿Qué estilo de visera preferís?",
      subtitle: "Plana o curva: cada una da un look distinto.",
      options: [
        { id: "flat_visor", label: "Visera plana – Actual y urbana" },
        { id: "curved_visor", label: "Visera curva – Clásica" },
        { id: "no_preference", label: "Sin preferencia" }
      ]
    },
    {
      id: "q3",
      question: "¿Qué estructura de copa te gusta?",
      subtitle: "Estructurada mantiene la forma; desestructurada es más suave.",
      options: [
        { id: "structured", label: "Estructurada – Mantiene su forma" },
        { id: "unstructured", label: "Desestructurada – Suave y relajada" },
        { id: "no_preference_crown", label: "Sin preferencia" }
      ]
    },
    {
      id: "q4",
      question: "¿Para qué la vas a usar más?",
      subtitle: "Cada gorra acompaña un estilo de vida distinto.",
      options: [
        { id: "everyday", label: "Día a día / uso casual" },
        { id: "sports", label: "Deporte y entrenamiento" },
        { id: "streetwear", label: "Streetwear y moda urbana" },
        { id: "golf_outdoors", label: "Aire libre" }
      ]
    },
    {
      id: "q5",
      question: "¿Qué altura de copa preferís?",
      subtitle: "Es cuánto se levanta el frente de la gorra.",
      options: [
        { id: "high_profile", label: "Alta – Frente más alto" },
        { id: "mid_profile", label: "Media – Equilibrada" },
        { id: "low_profile", label: "Baja – Pegada a la cabeza" },
        { id: "no_preference", label: "Sin preferencia" }
      ]
    }
  ];

  function hydrateQuestions(raw) {
    var source = raw && raw.length ? raw : DEFAULT_QUESTIONS;
    return source
      .map(function (q) {
        var options = (q.options || [])
          .filter(function (o) { return o && o.id && o.label; })
          .map(function (o) {
            return {
              id: o.id,
              label: o.label,
              weights: OPTION_WEIGHTS[o.id] || {}
            };
          });
        return {
          id: q.id,
          question: q.question,
          subtitle: q.subtitle,
          options: options
        };
      })
      .filter(function (q) { return q.question && q.options.length; });
  }

  var RINGS = [
    { key: "inner", count: 14, className: "lop-fyf__cap--inner", desktop: 320, mobile: 180, opacity: 0.8 },
    { key: "outer", count: 20, className: "lop-fyf__cap--outer", desktop: 460, mobile: 260, opacity: 0.55 },
    { key: "third", count: 26, className: "lop-fyf__cap--third", desktop: 580, mobile: 320, opacity: 0.35 }
  ];

  var INTRO = {
    titleDelay: 200,
    titleMs: 650,
    titleStagger: 30,
    capStart: 1000,
    capMs: 550,
    capStagger: 42,
    contentPad: 150,
    descMs: 300,
    ctaLag: 180,
    ease3: "cubic-bezier(0.215, 0.61, 0.355, 1)",
    ease2: "cubic-bezier(0.25, 0.46, 0.45, 0.94)"
  };

  var TRANS = {
    outMs: 150,
    inMs: 150,
    staggerMs: 60,
    selectDelay: 200,
    ease: "cubic-bezier(0.215, 0.61, 0.355, 1)",
    easeNum: "cubic-bezier(0.19, 1, 0.22, 1)"
  };

  function readConfig(root) {
    var el = root.querySelector("[data-lop-fyf-config]");
    if (!el) return { catalog: [], ui: {} };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { catalog: [], ui: {} };
    }
  }

  function makeCapSeeds() {
    var total = RINGS.reduce(function (sum, ring) { return sum + ring.count; }, 0);
    var seeds = [];
    for (var i = 0; i < total; i++) {
      seeds.push({
        rot: Math.round(Math.random() * 30 - 15),
        dur: (3.5 + Math.random() * 2.4).toFixed(2),
        delay: (Math.random() * 0.8).toFixed(2)
      });
    }
    return seeds;
  }

  function renderRings(root, images, seeds) {
    var wrap = root.querySelector("[data-lop-fyf-rings]");
    if (!wrap || !images.length) return { allCaps: [], byRing: {} };
    wrap.innerHTML = "";
    var isDesk = window.matchMedia("(min-width: 768px)").matches;
    var start = -Math.PI / 2 + Math.PI / 7;
    var seedIdx = 0;
    var allCaps = [];
    var byRing = {};
    RINGS.forEach(function (ring, ringIndex) {
      byRing[ring.key] = [];
      var radius = isDesk ? ring.desktop : ring.mobile;
      for (var i = 0; i < ring.count; i++) {
        var seed = seeds[seedIdx++] || { rot: 0, dur: "3.6", delay: "0" };
        var angle = start + (i / ring.count) * Math.PI * 2;
        var img = document.createElement("img");
        img.className = "lop-fyf__cap " + ring.className;
        img.src = images[(i + ringIndex) % images.length];
        img.alt = "";
        img.decoding = "async";
        img.loading = ring.key === "inner" ? "eager" : "lazy";
        img.style.setProperty("--lop-fyf-cap-x", Math.cos(angle) * radius + "px");
        img.style.setProperty("--lop-fyf-cap-y", Math.sin(angle) * radius + "px");
        img.style.setProperty("--lop-fyf-cap-rot", seed.rot + "deg");
        img.style.setProperty("--lop-fyf-float-d", seed.dur + "s");
        img.style.setProperty("--lop-fyf-float-delay", seed.delay + "s");
        img.style.opacity = "0";
        wrap.appendChild(img);
        byRing[ring.key].push(img);
        allCaps.push(img);
      }
    });
    return { allCaps: allCaps, byRing: byRing };
  }

  function repositionRings(byRing) {
    var isDesk = window.matchMedia("(min-width: 768px)").matches;
    var start = -Math.PI / 2 + Math.PI / 7;
    RINGS.forEach(function (ring) {
      var radius = isDesk ? ring.desktop : ring.mobile;
      (byRing[ring.key] || []).forEach(function (el, i) {
        var angle = start + (i / ring.count) * Math.PI * 2;
        el.style.setProperty("--lop-fyf-cap-x", Math.cos(angle) * radius + "px");
        el.style.setProperty("--lop-fyf-cap-y", Math.sin(angle) * radius + "px");
      });
    });
  }

  var CURVED_VISOR_KEYS = { "39THIRTY": true, "9FORTY": true };
  var FLAT_VISOR_KEYS = { "59FIFTY": true, "9FIFTY": true };

  function visorAllowsKey(answers, key) {
    var wantsStretch = answers.indexOf("stretch_fit") !== -1;
    var wantsCurved = answers.indexOf("curved_visor") !== -1;
    var wantsFlat = answers.indexOf("flat_visor") !== -1;
    if (wantsStretch && key === "39THIRTY") return true;
    if (wantsCurved) return !!CURVED_VISOR_KEYS[key];
    if (wantsFlat) return !!FLAT_VISOR_KEYS[key];
    return true;
  }

  function scoreAnswers(answers, catalog, questions) {
    var pool = (catalog || []).filter(function (item) {
      return item && AR_KEYS[item.key] && item.shop_url && visorAllowsKey(answers, item.key);
    });
    var scores = {};
    pool.forEach(function (item) {
      scores[item.key] = 0;
    });
    answers.forEach(function (optId, qi) {
      var q = questions[qi];
      if (!q) return;
      var opt = q.options.filter(function (o) { return o.id === optId; })[0];
      if (!opt) return;
      Object.keys(opt.weights).forEach(function (key) {
        if (scores[key] == null) return;
        scores[key] += opt.weights[key];
      });
    });
    if (answers.indexOf("stretch_fit") !== -1 && scores["39THIRTY"] != null) {
      var peak = 0;
      Object.keys(scores).forEach(function (key) {
        if (key !== "39THIRTY" && scores[key] > peak) peak = scores[key];
      });
      scores["39THIRTY"] = peak + 1;
    }
    return pool
      .slice()
      .sort(function (a, b) {
        return (scores[b.key] || 0) - (scores[a.key] || 0);
      })
      .filter(function (item) { return (scores[item.key] || 0) > 0; })
      .slice(0, 3);
  }

  function init(root) {
    if (!root || root.getAttribute("data-lop-fyf-inited") === "true") return;
    root.setAttribute("data-lop-fyf-inited", "true");

    var config = readConfig(root);
    var catalog = (config.catalog || []).filter(function (item) {
      return item && AR_KEYS[item.key];
    });
    var ui = config.ui || {};
    var questions = hydrateQuestions(config.questions);
    var images = catalog.map(function (c) { return c.image; }).filter(Boolean);
    var answers = [];
    var step = 0;
    var animating = false;
    var direction = "forward";
    var lastStepLabel = "";

    var cover = root.querySelector("[data-lop-fyf-cover]");
    var startBtn = root.querySelector("[data-lop-fyf-start]");
    var backBtn = root.querySelector("[data-lop-fyf-back]");
    var qTitle = root.querySelector("[data-lop-fyf-q-title]");
    var qSub = root.querySelector("[data-lop-fyf-q-sub]");
    var answersEl = root.querySelector("[data-lop-fyf-answers]");
    var fill = root.querySelector("[data-lop-fyf-fill]");
    var label = root.querySelector("[data-lop-fyf-label]");
    var hat = root.querySelector("[data-lop-fyf-hat]");
    var resultsEl = root.querySelector("[data-lop-fyf-results-grid]");
    var restartBtn = root.querySelector("[data-lop-fyf-restart]");

    var coverTitle = root.querySelector("[data-lop-fyf-cover-title]");
    var coverDesc = root.querySelector("[data-lop-fyf-cover-desc]");
    var capSeeds = makeCapSeeds();
    var ringState = renderRings(root, images, capSeeds);
    var introPlayed = false;
    var titleChars = null;

    function prefersReduced() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    function splitCoverTitle() {
      if (titleChars || !coverTitle) return;
      var text = (coverTitle.textContent || "").trim();
      coverTitle.setAttribute("aria-label", coverTitle.getAttribute("aria-label") || text);
      coverTitle.textContent = "";
      titleChars = [];
      var words = text.split(/\s+/).filter(Boolean);
      words.forEach(function (word, wi) {
        var wordSpan = document.createElement("span");
        wordSpan.className = "lop-fyf__word";
        Array.from(word).forEach(function (ch) {
          var span = document.createElement("span");
          span.className = "lop-fyf__char";
          span.setAttribute("aria-hidden", "true");
          span.textContent = ch;
          span.style.opacity = "0";
          wordSpan.appendChild(span);
          titleChars.push(span);
        });
        coverTitle.appendChild(wordSpan);
        if (wi < words.length - 1) {
          coverTitle.appendChild(document.createTextNode(" "));
        }
      });
    }

    function showCoverInstant() {
      RINGS.forEach(function (ring) {
        (ringState.byRing[ring.key] || []).forEach(function (el) {
          el.style.opacity = String(ring.opacity);
          el.classList.add("is-floating");
        });
      });
      if (titleChars) {
        titleChars.forEach(function (el) {
          el.style.opacity = "1";
          el.style.transform = "none";
        });
      } else if (coverTitle) {
        coverTitle.style.opacity = "1";
      }
      if (coverDesc) {
        coverDesc.style.opacity = "1";
        coverDesc.style.transform = "none";
      }
      if (startBtn) {
        startBtn.style.opacity = "1";
        startBtn.style.transform = "none";
      }
      root.classList.add("is-cover-inited");
    }

    function playCoverIntro() {
      introPlayed = true;
      splitCoverTitle();
      root.classList.add("is-cover-inited");
      if (prefersReduced()) {
        showCoverInstant();
        return;
      }
      if (!canAnimate(coverTitle || startBtn || ringState.allCaps[0])) {
        showCoverInstant();
        return;
      }

      if (titleChars && titleChars.length) {
        titleChars.forEach(function (el, i) {
          el.animate(
            [
              { opacity: 0, transform: "translateY(8px)" },
              { opacity: 1, transform: "translateY(0px)" }
            ],
            {
              duration: INTRO.titleMs,
              delay: INTRO.titleDelay + i * INTRO.titleStagger,
              easing: INTRO.ease3,
              fill: "forwards"
            }
          );
        });
      } else if (coverTitle) {
        coverTitle.animate(
          [{ opacity: 0 }, { opacity: 1 }],
          { duration: 500, delay: INTRO.titleDelay, easing: INTRO.ease3, fill: "forwards" }
        );
      }

      var maxCount = 0;
      RINGS.forEach(function (ring) {
        var caps = ringState.byRing[ring.key] || [];
        if (caps.length > maxCount) maxCount = caps.length;
        caps.forEach(function (el, i) {
          el.animate(
            [{ opacity: 0 }, { opacity: ring.opacity }],
            {
              duration: INTRO.capMs,
              delay: INTRO.capStart + i * INTRO.capStagger,
              easing: INTRO.ease3,
              fill: "forwards"
            }
          );
        });
        window.setTimeout(function () {
          caps.forEach(function (el) {
            el.style.opacity = String(ring.opacity);
            el.classList.add("is-floating");
          });
        }, INTRO.capStart + Math.max(caps.length - 1, 0) * INTRO.capStagger + INTRO.capMs);
      });

      var contentDelay = INTRO.capStart + maxCount * INTRO.capStagger + INTRO.contentPad;
      if (coverDesc && canAnimate(coverDesc)) {
        coverDesc.animate(
          [
            { opacity: 0, transform: "translateY(8px)" },
            { opacity: 1, transform: "translateY(0px)" }
          ],
          { duration: INTRO.descMs, delay: contentDelay, easing: INTRO.ease2, fill: "forwards" }
        ).onfinish = function () {
          coverDesc.style.opacity = "1";
          coverDesc.style.transform = "none";
        };
      } else if (coverDesc) {
        coverDesc.style.opacity = "1";
      }
      if (startBtn && canAnimate(startBtn)) {
        startBtn.animate(
          [
            { opacity: 0, transform: "translateY(8px)" },
            { opacity: 1, transform: "translateY(0px)" }
          ],
          {
            duration: INTRO.descMs,
            delay: contentDelay + INTRO.ctaLag,
            easing: INTRO.ease2,
            fill: "forwards"
          }
        ).onfinish = function () {
          startBtn.style.opacity = "1";
          startBtn.style.transform = "none";
        };
      } else if (startBtn) {
        startBtn.style.opacity = "1";
      }
    }

    function canAnimate(el) {
      return el && typeof el.animate === "function" && !prefersReduced();
    }

    function cancelAnims(els) {
      els.forEach(function (el) {
        if (!el) return;
        if (el.getAnimations) {
          el.getAnimations().forEach(function (anim) {
            anim.cancel();
          });
        }
        el.style.removeProperty("opacity");
        el.style.removeProperty("transform");
      });
    }

    function resetActionsEl() {
      var actions = root.querySelector(".lop-fyf__questions .lop-fyf__actions");
      if (actions) cancelAnims([actions]);
      if (backBtn) {
        backBtn.style.removeProperty("opacity");
        backBtn.style.removeProperty("transform");
      }
    }

    function collectAnimEls() {
      var els = [];
      if (root.classList.contains("is-results")) {
        var results = root.querySelector(".lop-fyf__results");
        if (!results) return els;
        var rt = results.querySelector(".lop-fyf__results-title");
        var rs = results.querySelector(".lop-fyf__results-sub");
        if (rt) els.push(rt);
        if (rs) els.push(rs);
        results.querySelectorAll(".lop-fyf__card").forEach(function (card) {
          els.push(card);
        });
        var foot = results.querySelector(".lop-fyf__footer-actions");
        if (foot) els.push(foot);
        return els;
      }
      if (qTitle) els.push(qTitle);
      if (qSub && (qSub.textContent || "").trim()) els.push(qSub);
      if (answersEl) {
        answersEl.querySelectorAll(".lop-fyf__answer").forEach(function (btn) {
          els.push(btn);
        });
      }
      var actions = root.querySelector(".lop-fyf__questions .lop-fyf__actions");
      if (actions) els.push(actions);
      return els;
    }

    function runStagger(els, keyframes, fromEnd, duration, onDone) {
      var called = false;
      var finish = function () {
        if (called) return;
        called = true;
        if (onDone) onDone();
      };
      if (!els.length || !canAnimate(els[0])) {
        finish();
        return;
      }
      var maxDelay = (els.length - 1) * TRANS.staggerMs;
      els.forEach(function (el, i) {
        var delay = (fromEnd ? els.length - 1 - i : i) * TRANS.staggerMs;
        el.animate(keyframes, {
          duration: duration,
          delay: delay,
          easing: TRANS.ease,
          fill: "forwards"
        });
      });
      window.setTimeout(finish, maxDelay + duration + 80);
    }

    function animateOut(done) {
      var els = collectAnimEls();
      var numEl = root.querySelector("[data-lop-fyf-step-num]");
      lastStepLabel = numEl ? numEl.textContent : "";
      if (!els.length || prefersReduced()) {
        cancelAnims(els);
        resetActionsEl();
        if (done) done();
        return;
      }
      cancelAnims(els);
      runStagger(
        els,
        [
          { transform: "translate3d(0, 0, 0)", opacity: 1 },
          { transform: "translate3d(0, 12px, 0)", opacity: 0 }
        ],
        true,
        TRANS.outMs,
        done
      );
    }

    function setIncomingStart(els) {
      els.forEach(function (el) {
        if (!el) return;
        if (el.getAnimations) {
          el.getAnimations().forEach(function (anim) {
            try {
              if (typeof anim.commitStyles === "function") anim.commitStyles();
            } catch (err) {}
            anim.cancel();
          });
        }
        el.style.opacity = "0";
        el.style.transform = "translate3d(0, 16px, 0)";
      });
    }

    function rollStepNumber() {
      var wrap = root.querySelector(".lop-fyf__step-num-wrap");
      var numEl = root.querySelector("[data-lop-fyf-step-num]");
      if (!wrap || !numEl || !lastStepLabel || lastStepLabel === numEl.textContent) return;
      if (!canAnimate(numEl)) return;
      var forward = direction === "forward";
      var ghost = document.createElement("span");
      ghost.className = "lop-fyf__step-num lop-fyf__step-num--ghost";
      ghost.textContent = lastStepLabel;
      wrap.appendChild(ghost);
      var startY = forward ? "100%" : "-100%";
      var ghostTo = forward ? "-100%" : "100%";
      var dur = Math.round(TRANS.inMs * 1.4);
      numEl.animate(
        [{ transform: "translateY(" + startY + ")" }, { transform: "translateY(0)" }],
        { duration: dur, easing: TRANS.easeNum, fill: "forwards" }
      ).onfinish = function () {
        numEl.style.transform = "";
      };
      ghost.animate(
        [{ transform: "translateY(0)" }, { transform: "translateY(" + ghostTo + ")" }],
        { duration: dur, easing: TRANS.easeNum, fill: "forwards" }
      ).onfinish = function () {
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      };
    }

    function celebrateHat() {
      if (!hat || prefersReduced()) return;
      hat.removeEventListener("animationend", onHatCelebrateEnd);
      hat.classList.remove("is-celebrating");
      void hat.offsetWidth;
      hat.classList.add("is-celebrating");
      hat.addEventListener("animationend", onHatCelebrateEnd, { once: true });
    }

    function onHatCelebrateEnd() {
      if (hat) hat.classList.remove("is-celebrating");
    }

    function animateIn() {
      var els = collectAnimEls();
      celebrateHat();
      if (!els.length || prefersReduced()) {
        resetActionsEl();
        animating = false;
        return;
      }
      setIncomingStart(els);
      requestAnimationFrame(function () {
        rollStepNumber();
        runStagger(
          els,
          [
            { transform: "translate3d(0, 16px, 0)", opacity: 0 },
            { transform: "translate3d(0, 0, 0)", opacity: 1 }
          ],
          false,
          TRANS.inMs,
          function () {
            cancelAnims(els);
            resetActionsEl();
            animating = false;
          }
        );
      });
    }

    function transitionThen(next) {
      if (animating) return;
      animating = true;
      animateOut(function () {
        next();
        animateIn();
      });
    }

    function progressRatio() {
      if (root.classList.contains("is-results")) return 1;
      return (step + 1) / (questions.length + 1);
    }

    function setProgressLabel() {
      if (!label) return;
      var tpl = ui.progress_label || "Pregunta {current} de {total}";
      var parts = tpl.split("{current}");
      label.textContent = "";
      if (parts[0]) label.appendChild(document.createTextNode(parts[0]));
      var wrap = document.createElement("span");
      wrap.className = "lop-fyf__step-num-wrap";
      var num = document.createElement("span");
      num.className = "lop-fyf__step-num";
      num.setAttribute("data-lop-fyf-step-num", "");
      num.textContent = String(step + 1);
      wrap.appendChild(num);
      label.appendChild(wrap);
      var rest = (parts[1] || "").replace("{total}", String(questions.length));
      if (rest) label.appendChild(document.createTextNode(rest));
    }

    function renderQuestion() {
      var q = questions[step];
      if (!q) return;
      qTitle.textContent = q.question;
      qSub.textContent = q.subtitle;
      setProgressLabel();
      fill.style.transform = "scaleX(" + progressRatio() + ")";
      if (hat) hat.style.setProperty("--lop-fyf-hat-x", Math.round(progressRatio() * 100) + "%");
      if (!animating) resetActionsEl();
      backBtn.disabled = step === 0;
      backBtn.setAttribute("aria-disabled", step === 0 ? "true" : "false");
      answersEl.innerHTML = "";
      q.options.forEach(function (opt, i) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "lop-fyf__answer";
        btn.setAttribute("role", "radio");
        btn.setAttribute("aria-checked", "false");
        btn.textContent = opt.label;
        if (animating && !prefersReduced()) {
          btn.style.opacity = "0";
          btn.style.transform = "translate3d(0, 16px, 0)";
        }
        btn.addEventListener("click", function () {
          if (animating) return;
          animating = true;
          btn.classList.add("is-selected");
          btn.setAttribute("aria-checked", "true");
          answers[step] = opt.id;
          window.setTimeout(function () {
            direction = "forward";
            animateOut(function () {
              if (step < questions.length - 1) {
                step += 1;
                answers = answers.slice(0, step);
                renderQuestion();
              } else {
                showResults();
              }
              animateIn();
            });
          }, TRANS.selectDelay);
        });
        answersEl.appendChild(btn);
        if (i === 0) btn.tabIndex = 0;
      });
      if (animating && !prefersReduced()) setIncomingStart(collectAnimEls());
    }

    function showResults() {
      var top = scoreAnswers(answers, catalog, questions);
      root.classList.add("is-results");
      fill.style.transform = "scaleX(1)";
      if (hat) hat.style.setProperty("--lop-fyf-hat-x", "100%");
      resultsEl.textContent = "";
      top.forEach(function (item, i) {
        var card = document.createElement("article");
        card.className = "lop-fyf__card";

        if (item.image) {
          var wrap = document.createElement("div");
          wrap.className = "lop-fyf__card-image-wrap";
          if (i === 0) {
            var badge = document.createElement("span");
            badge.className = "lop-fyf__badge";
            badge.textContent = ui.best_match || "Mejor match";
            wrap.appendChild(badge);
          }
          var img = document.createElement("img");
          img.className = "lop-fyf__card-image";
          img.src = item.image;
          img.alt = item.title || "";
          wrap.appendChild(img);
          card.appendChild(wrap);
        }

        var content = document.createElement("div");
        content.className = "lop-fyf__card-content";
        var head = document.createElement("div");
        head.className = "lop-fyf__card-head";
        var h3 = document.createElement("h3");
        h3.className = "lop-fyf__card-title";
        h3.textContent = item.title || "";
        head.appendChild(h3);
        if (item.fit) {
          var fit = document.createElement("span");
          fit.className = "lop-fyf__card-fit";
          fit.textContent = item.fit;
          head.appendChild(fit);
        }
        content.appendChild(head);
        if (item.description) {
          var desc = document.createElement("p");
          desc.className = "lop-fyf__card-desc";
          desc.textContent = item.description;
          content.appendChild(desc);
        }
        var feats = document.createElement("div");
        feats.className = "lop-fyf__features";
        (item.features || []).filter(Boolean).forEach(function (f) {
          var pill = document.createElement("span");
          pill.className = "lop-fyf__feature";
          pill.textContent = f;
          feats.appendChild(pill);
        });
        content.appendChild(feats);
        card.appendChild(content);
        var actions = document.createElement("div");
        actions.className = "lop-fyf__card-actions";
        if (item.learn_more_url) {
          var view = document.createElement("a");
          view.className = "lop-fyf__btn lop-fyf__btn--ghost";
          view.href = item.learn_more_url;
          view.textContent = ui.view_page || "Ver página";
          actions.appendChild(view);
        }
        if (item.shop_url) {
          var shop = document.createElement("a");
          shop.className = "lop-fyf__btn";
          shop.href = item.shop_url;
          shop.textContent = ui.shop_product || "Ver productos";
          actions.appendChild(shop);
        }
        card.appendChild(actions);
        resultsEl.appendChild(card);
      });
      if (animating && !prefersReduced()) setIncomingStart(collectAnimEls());
    }

    function startQuiz() {
      root.classList.add("is-started");
      if (cover) cover.classList.add("is-hidden");
      step = 0;
      answers = [];
      direction = "forward";
      lastStepLabel = "";
      root.classList.remove("is-results");
      animating = true;
      renderQuestion();
      animateIn();
    }

    if (startBtn) startBtn.addEventListener("click", startQuiz);
    if (backBtn) {
      backBtn.addEventListener("click", function () {
        if (step === 0 || animating) return;
        direction = "backward";
        transitionThen(function () {
          step -= 1;
          answers = answers.slice(0, step);
          renderQuestion();
        });
      });
    }
    if (restartBtn) {
      restartBtn.addEventListener("click", function () {
        if (animating) return;
        direction = "forward";
        lastStepLabel = "";
        transitionThen(function () {
          step = 0;
          answers = [];
          root.classList.remove("is-results");
          renderQuestion();
        });
      });
    }

    var resizeTimer = null;
    var onResize = function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (introPlayed) {
          repositionRings(ringState.byRing);
        } else {
          ringState = renderRings(root, images, capSeeds);
          playCoverIntro();
        }
      }, 160);
    };
    window.addEventListener("resize", onResize);
    playCoverIntro();

    root._lopFyfCleanup = function () {
      window.removeEventListener("resize", onResize);
    };
  }

  function boot() {
    document.querySelectorAll("[data-lop-fyf]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e.target) init(e.target.querySelector("[data-lop-fyf]"));
  });

  document.addEventListener("shopify:section:unload", function (e) {
    var root = e.target && e.target.querySelector("[data-lop-fyf]");
    if (root && typeof root._lopFyfCleanup === "function") root._lopFyfCleanup();
  });
})();
